import { Dialog, DialogContent } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Button from '../../../components/Button';

interface RegularUnavailableModalProps {
    isOpen: boolean;
    onClose: () => void;
    time?: string;
}

const RegularUnavailableModal: React.FC<RegularUnavailableModalProps> = ({ isOpen, onClose, time }) => {
    const { t } = useTranslation();

    return (
        <Dialog
            open={isOpen}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: '16px',
                    margin: 2,
                },
            }}
        >
            {/* Header */}
            <div className="flex items-center justify-between p-4 border-b">
                <h2 className="text-lg font-semibold">{t('REGULAR_UNAVAILABLE_TITLE')}</h2>
            </div>

            {/* Content */}
            <DialogContent sx={{ padding: '16px' }}>
                <div className="flex flex-col gap-5">
                    <p className="text-gray-700 mb-4">{t('REGULAR_UNAVAILABLE_TIME', { time })}</p>

                    {/* Close Button */}
                    <Button onClick={onClose} type="submit">
                        {t('REGULAR_UNAVAILABLE_CLOSE')}
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default RegularUnavailableModal;
